// Behavioral activation candidate, not proof of prediction accuracy or conversion.
export type Resonance = 'fits' | 'partly' | 'not_me';
export type ActivationState = {
  exposed: boolean; evidenceOpened: boolean; resonance: Resonance | null;
  action: 'try_step' | 'check_first' | null;
};
export const initialActivationState: ActivationState = { exposed: false, evidenceOpened: false, resonance: null, action: null };
export type ActivationAction =
  | { type: 'exposed' } | { type: 'evidence' }
  | { type: 'resonance'; value: Resonance }
  | { type: 'action'; value: NonNullable<ActivationState['action']> };
export function activationReducer(state: ActivationState, action: ActivationAction): ActivationState {
  if (action.type === 'exposed') return { ...state, exposed: true };
  if (action.type === 'evidence') return { ...state, evidenceOpened: true };
  if (action.type === 'resonance') return { ...state, resonance: action.value, action: null };
  return { ...state, action: action.value };
}
export function isActivationCandidate(state: ActivationState, example: boolean) {
  return !example && state.exposed && state.evidenceOpened
    && (state.resonance === 'fits' || state.resonance === 'partly') && Boolean(state.action);
}
export const ACTIVATION_EXPOSURE_MS = 4000;
